import { Button, Col, Row } from 'antd';

interface EmailVerificationResultComponentProps {
  verified: string;
  moveToSignInPage: () => void;
}
function EmailVerificationResultComponent({
  verified,
  moveToSignInPage,
}: EmailVerificationResultComponentProps) {
  return (
    <>
      <Row justify="center" align="middle" style={{ marginTop: '100px' }}>
        <Col span={12}>
          <Row justify="center">
            <Col flex={1}>
              <Row justify="center">
                <Col>
                  <h2>
                    이메일 인증을 {verified === 'true' ? '완료' : '실패'}{' '}
                    하였습니다.
                  </h2>
                </Col>
              </Row>
              {verified === 'true' && (
                <Row justify="center">
                  <Col>
                    <Button onClick={() => moveToSignInPage()}>
                      로그인 후 회사설정 하기
                    </Button>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default EmailVerificationResultComponent;
